var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { TextField as MuiTextField } from "@mui/material";
import React, { useRef, useState } from "react";
export function TextField(_a) {
    var _b;
    var { onChange, validate, onBlur, helperText, select, SelectProps } = _a, props = __rest(_a, ["onChange", "validate", "onBlur", "helperText", "select", "SelectProps"]);
    const input = useRef();
    const [validationCount, setValidationCount] = useState(0);
    const incValidationCount = () => setValidationCount(v => v + 1);
    const wasValidated = validationCount > 0;
    const error = wasValidated && input.current != null && !input.current.validity.valid;
    function maybeUpdateValidity(value) {
        var _a;
        if (wasValidated) {
            if (validate) {
                (_a = input.current) === null || _a === void 0 ? void 0 : _a.setCustomValidity(validate(value) || "");
            }
            incValidationCount();
        }
    }
    function handleChange(e) {
        var _a;
        const value = ((_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.value) || e.target.value;
        maybeUpdateValidity(value);
        if (onChange) {
            onChange(value, e);
        }
    }
    function handleBlur(e) {
        var _a;
        const value = ((_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.value) || e.target.value;
        maybeUpdateValidity(value);
        if (onBlur) {
            onBlur(e);
        }
    }
    // Despite typed differently, a MUI TextField with the `select` property set,
    // provides a ref that is an object with a `node` property which contains the
    // actual input element. We handle both cases here.
    function handleInputRef(ref) {
        const element = ref instanceof HTMLInputElement || ref instanceof HTMLTextAreaElement ? ref : ref === null || ref === void 0 ? void 0 : ref.node;
        if (element) {
            input.current = element;
        }
    }
    return (React.createElement(MuiTextField, Object.assign({}, props, { select: select, SelectProps: SelectProps && Object.assign(Object.assign({}, SelectProps), { native: true }), onChange: handleChange, onInvalid: incValidationCount, onBlur: handleBlur, inputRef: handleInputRef, error: error, helperText: error ? (_b = input.current) === null || _b === void 0 ? void 0 : _b.validationMessage : helperText })));
}
//# sourceMappingURL=TextField.js.map